import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
} from "@mui/material";
import axios from "axios";

function RestauraContrasena() {
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Decodifica correctamente el hash para evitar pérdida de caracteres
  const queryParams = new URLSearchParams(location.search);
  const hashParam = queryParams.get("hash");
  const hash = decodeURIComponent(hashParam || "").replace(/ /g, "+");

  const [correo, setCorreo] = useState("");
  const [nuevaContrasena, setNuevaContrasena] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!correo || !nuevaContrasena) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor complete todos los campos",
      });
      return;
    }

    try {
      const payload = {
        hash: hash,
        correo: correo,
        nuevaContrasena: nuevaContrasena,
      };

      // ✅ Capturamos la respuesta del API
      const response = await axios.put(
        "https://suadesarrollo.azurewebsites.net/api/ActualizaUsuarios/RestableceContrasenaUsuario",
        payload,
      );

      // ✅ Mostramos el mensaje que envía el API (por ejemplo "Contraseña actualizada correctamente")
      Swal.fire({
        icon: "success",
        title: "Atención",
        text: response.data || "Contraseña actualizada correctamente",
        confirmButtonText: "Acceder",
      }).then(() => {
        navigate("/"); // Redirige a inicio
      });
    } catch (error) {
      console.error("Error al actualizar la contraseña:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data ||
          "No se pudo actualizar la contraseña. Intente de nuevo o genere el correo nuevamente.",
      });
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Recuperar Contraseña
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{ mb: 3, wordBreak: "break-all" }}
        >
          {/* ✅ Muestra el hash decodificado (opcional, útil para depuración) */}
          Hash: {hash}
        </Typography>
        <Typography variant="body2" align="center" sx={{ mb: 3 }}>
          Ingrese su correo y nueva contraseña para continuar
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Correo electrónico"
            type="email"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Nueva contraseña"
            type="password"
            value={nuevaContrasena}
            onChange={(e) => setNuevaContrasena(e.target.value)}
            fullWidth
            margin="normal"
          />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{ mt: 2 }}
          >
            Restablecer Contraseña
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default RestauraContrasena;
